/** Icons generated by create-react-icons. Don't edit this file directly. **/
import React from "react";
import PropTypes from "prop-types";

export function ClientApplication(props) {
  const { size, color, ...other } = props;
  return (
    <svg viewBox="0 0 24 24" fill="none" height={size} width={size} {...other}>
      <path
        d="M17.2823 3H5.98943C5.72686 3.00086 5.47532 3.10572 5.28989 3.29161C5.10445 3.47751 5.00021 3.7293 5 3.99188V20.3191C5.00043 20.582 5.1051 20.8339 5.29104 21.0197C5.47698 21.2055 5.72902 21.31 5.99187 21.3102H17.2823C17.5453 21.3102 17.7975 21.2058 17.9837 21.02C18.1698 20.8342 18.2746 20.5821 18.275 20.3191V3.99188C18.2746 3.72881 18.1698 3.47665 17.9837 3.2907C17.7976 3.10476 17.5454 3.00022 17.2823 3ZM11.1607 20.1007C11.1579 19.9785 11.2009 19.8597 11.2813 19.7676C11.3617 19.6756 11.4736 19.617 11.5951 19.6034C11.7165 19.5897 11.8387 19.6221 11.9375 19.694C12.0363 19.766 12.1045 19.8723 12.1288 19.9921C12.1531 20.1119 12.1317 20.2364 12.0688 20.3411C12.0058 20.4459 11.9059 20.5233 11.7888 20.5581C11.6716 20.5929 11.5457 20.5825 11.4358 20.5291C11.3259 20.4757 11.2399 20.383 11.1949 20.2694C11.173 20.2158 11.1614 20.1586 11.1607 20.1007ZM6.03833 19.0615V5.31628H17.2342V19.0615H6.03833ZM13.1225 4.28528C13.1225 4.29413 13.1207 4.30288 13.1173 4.31105C13.1139 4.31921 13.1089 4.32661 13.1026 4.33283C13.0963 4.33905 13.0888 4.34395 13.0806 4.34726C13.0724 4.35057 13.0637 4.35222 13.0548 4.35211H10.2161C10.2073 4.35222 10.1985 4.35057 10.1903 4.34726C10.1821 4.34395 10.1746 4.33905 10.1683 4.33283C10.162 4.32661 10.157 4.31921 10.1536 4.31105C10.1502 4.30288 10.1485 4.29413 10.1485 4.28528C10.1485 4.26734 10.1556 4.25013 10.1683 4.23745C10.181 4.22476 10.1982 4.21764 10.2161 4.21764H13.0532C13.0622 4.21742 13.0712 4.21901 13.0796 4.22231C13.088 4.22561 13.0956 4.23056 13.1021 4.23686C13.1085 4.24317 13.1137 4.2507 13.1172 4.25901C13.1207 4.26733 13.1225 4.27626 13.1225 4.28528Z"
        fill={color}
      />
      <path
        d="M9.37013 6.68307H7.66675V8.38645H9.37013V6.68307Z"
        fill={color}
      />
      <path
        d="M12.4875 6.68307H10.7841V8.38645H12.4875V6.68307Z"
        fill={color}
      />
      <path
        d="M15.6051 6.68307H13.9017V8.38645H15.6051V6.68307Z"
        fill={color}
      />
      <path
        d="M9.37013 9.39544H7.66675V11.0988H9.37013V9.39544Z"
        fill={color}
      />
      <path
        d="M12.4875 9.39544H10.7841V11.0988H12.4875V9.39544Z"
        fill={color}
      />
      <path
        d="M15.6051 9.39544H13.9017V11.0988H15.6051V9.39544Z"
        fill={color}
      />
      <path d="M9.37013 12.107H7.66675V13.8104H9.37013V12.107Z" fill={color} />
      <path d="M12.4875 12.107H10.7841V13.8104H12.4875V12.107Z" fill={color} />
      <path d="M15.6051 12.107H13.9017V13.8104H15.6051V12.107Z" fill={color} />
      <path
        d="M9.37013 14.8194H7.66675V16.5228H9.37013V14.8194Z"
        fill={color}
      />
      <path
        d="M12.4875 14.8194H10.7841V16.5228H12.4875V14.8194Z"
        fill={color}
      />
      <path
        d="M15.6051 14.8194H13.9017V16.5228H15.6051V14.8194Z"
        fill={color}
      />
    </svg>
  );
}

ClientApplication.defaultProps = {
  color: "currentColor",
  size: 24,
};

ClientApplication.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};
